/**
 * Valida se uma data está no formato dd/mm/aaaa e é válida
 * @param {string} value - Data no formato dd/mm/aaaa
 * @param {Date} maxDate - Data máxima permitida (padrão: hoje)
 * @returns {boolean} - true se a data é válida
 */
export const validateDate = (value, maxDate = new Date()) => {
  if (!value || value.length < 10) return false;
  
  const numbers = value.replace(/\D/g, "");
  if (numbers.length !== 8) return false;
  
  const [day, month, year] = value.split('/');
  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
  
  return date.getDate() === parseInt(day, 10) && 
         date.getMonth() === parseInt(month, 10) - 1 && 
         date.getFullYear() === parseInt(year, 10) &&
         date <= maxDate;
};

/**
 * Aplica máscara de data no formato dd/mm/aaaa
 * @param {string} value - Valor digitado
 * @returns {string} - Valor com máscara aplicada
 */
export const applyDateMask = (value) => {
  const numbers = value.replace(/\D/g, "");
  
  let masked = "";
  if (numbers.length >= 1) masked = numbers.slice(0, 2);
  if (numbers.length >= 3) masked = `${masked}/${numbers.slice(2, 4)}`;
  if (numbers.length >= 5) masked = `${masked}/${numbers.slice(4, 8)}`;
  
  return masked;
};

/**
 * Converte string de data para objeto Date
 * @param {string} dateString - Data no formato dd/mm/aaaa
 * @returns {Date|null} - Objeto Date ou null se inválida
 */
export const parseDate = (dateString) => {
  if (!dateString || dateString.length !== 10) {
    return null;
  }
  
  const [day, month, year] = dateString.split('/');
  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
  
  if (date.getDate() === parseInt(day, 10) && 
      date.getMonth() === parseInt(month, 10) - 1 && 
      date.getFullYear() === parseInt(year, 10)) {
    // Ajusta para evitar problemas de timezone
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  
  return null;
}; 